import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import TopNav from '../../components/top-nav';
import Footer from '../../components/footer';
import NewsletterSignup from '../../components/newsletter-signup';
import MasqueradeBanner from '../../components/masquerade-banner';
import ErrorBoundary from '../../components/error-boundary/ErrorBoundaryComponent';

type Props = {
  hideNav?: boolean;
  hidefooter?: boolean;
};

const LayoutWrapper = ({
  hideNav = false,
  hidefooter = false,
}: Props) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
    }}
  >
    <MasqueradeBanner />
    {hideNav ? null : (
      <ErrorBoundary fallback={<Box component="header" sx={{ height: 68, bgcolor: '#f0ece9' }} />}>
        <TopNav />
      </ErrorBoundary>
    )}
    <Box
      component="main"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        ...(!hideNav && { pt: '68px' }),
      }}
    >
      <Outlet />
      {hidefooter ? null : (
        <Box sx={{ mt: 'auto' }}>
          <NewsletterSignup />
          <Footer />
        </Box>
      )}
    </Box>
  </Box>
);

export default LayoutWrapper;
